import styled from '@emotion/styled'
import {theme} from './theme'

export const PageLayout = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: ${theme.colors.surface};
  font-family: ${theme.font.family};
`

export const MainWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
`

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: ${p => (p.previewing ? '0' : '24px 32px')};

  @media (max-width: 768px) {
    padding: ${p => (p.previewing ? '0' : '16px')};
  }

  @media (max-width: 480px) {
    padding: ${p => (p.previewing ? '0' : '12px')};
  }
`

export const MainArea = styled.div`
  background: ${theme.colors.bg};
  border-radius: ${theme.radius.lg};
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ModalBox = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radius.lg};
  padding: 24px 28px;
  max-width: 400px;
  width: 90%;
  box-shadow: ${theme.shadow.popout};
`

export const ModalTitle = styled.h3`
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
  color: ${theme.colors.text};
  font-family: ${theme.font.family};
`

export const ModalBody = styled.p`
  margin: 0 0 20px;
  font-size: 14px;
  color: ${theme.colors.muted};
  font-family: ${theme.font.family};
  line-height: 1.5;
`

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`

export const ModalCancelBtn = styled.button`
  padding: 8px 18px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.full};
  background: transparent;
  font-size: 14px;
  font-family: ${theme.font.family};
  color: ${theme.colors.muted};
  cursor: pointer;
  transition: background ${theme.transition.fast};

  &:hover {
    background: ${theme.colors.hover};
  }

  &:focus {
    outline: none;
  }
`

export const ModalDangerBtn = styled.button`
  padding: 8px 18px;
  border: none;
  border-radius: ${theme.radius.full};
  background: ${theme.colors.danger};
  font-size: 14px;
  font-weight: 600;
  font-family: ${theme.font.family};
  color: ${theme.colors.surface};
  cursor: pointer;
  transition: filter ${theme.transition.fast};

  &:hover {
    filter: brightness(1.1);
  }

  &:focus {
    outline: none;
  }
`

export const DuplicateModalBox = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radius.lg};
  padding: 28px 32px;
  max-width: 540px;
  width: 94%;
  box-shadow: ${theme.shadow.popout};
`

export const ModalOptionalNote = styled.p`
  margin: 0 0 20px;
  font-size: 13px;
  color: ${theme.colors.muted};
  font-family: ${theme.font.family};
  line-height: 1.4;
`

export const ModalFormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
  margin-bottom: 24px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  &.full-width {
    grid-column: 1 / -1;
  }
`

export const FormLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.text};
  font-family: ${theme.font.family};
  letter-spacing: 0.02em;
`

export const FormInput = styled.input`
  padding: 8px 12px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.md};
  font-size: 14px;
  font-family: ${theme.font.family};
  color: ${theme.colors.text};
  background: #fff;
  outline: none;
  transition: border-color ${theme.transition.fast};

  &::placeholder {
    color: ${theme.colors.placeholder};
  }

  &:focus {
    border-color: #495099;
  }
`

export const FormSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.md};
  font-size: 14px;
  font-family: ${theme.font.family};
  color: ${theme.colors.text};
  background: #fff;
  outline: none;
  cursor: pointer;
  transition: border-color ${theme.transition.fast};
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%236b7280' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 32px;

  &:focus {
    border-color: #495099;
  }
`

export const ModalPrimaryBtn = styled.button`
  padding: 8px 18px;
  border: none;
  border-radius: ${theme.radius.full};
  background: ${theme.colors.secondary};
  font-size: 14px;
  font-weight: 600;
  font-family: ${theme.font.family};
  color: #fff;
  cursor: pointer;
  transition: filter ${theme.transition.fast};

  &:hover {
    filter: brightness(1.1);
  }

  &:focus {
    outline: none;
  }
`
